import {HistoryState} from '@PosterWhiteboard/poster/poster-history/history-state';
import type {PosterOp} from '@PosterWhiteboard/collaboration/poster-op.types';

/**
 * One commit while editing together: the ops it sent and the ops that take it back. Undo and
 * redo apply these to whatever the poster is now (which may hold other people's edits) and send
 * the result as a new commit, so nobody else's work is rewound.
 */
export class HistoryStatePosterOps extends HistoryState {
  public constructor(
    public readonly ops: PosterOp[],
    public readonly inverseOps: PosterOp[]
  ) {
    super();
  }
}
